import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MessageSVG = function MessageSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27 4H5a3 3 0 00-3 3v12a3 3 0 003 3h3v6a1 1 0 00.08.38 1 1 0 00.54.54.94.94 0 00.76 0 1 1 0 00.33-.21l6.7-6.71H27a3 3 0 003-3V7a3 3 0 00-3-3z"
  }));
};
MessageSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MessageSVG);